export default class EnumHelper{
    getEnumKeys(_enum) {
        return Object.keys(_enum);
    }
}